<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',

  data() {
    return {
    }
  },
  created: function() {
    this.$http.interceptors.response.use(undefined, function(err) {
      return new Promise(function() {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch('logout')
        }
        throw err
      })
    })
  },
}
</script>

<style lang="scss">
$sizes: (0,2,4,6,8,10,15,20,25,30,50);
@each $size in $sizes {
  .mt#{$size} { margin-top: $size + px; }
  .mr#{$size} { margin-right: $size + px; }
  .mb#{$size} { margin-bottom: $size + px; }
  .ml#{$size} { margin-left: $size + px; }
}
.gray { color: #999; }
.greenText { color: #349940; }
.textBlack { color: black; }
.fs14 { font-size: 14px; }
</style>
